import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../servicios/api.service';
import { environment } from '../../../environments/environment'
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-app-navbar',
  templateUrl: './app-navbar.component.html',
  styleUrls: ['app-navbar.component.scss']
})

export class AppNavbarComponent implements OnInit {

  public mainNavbar: any;
  public windowHeight: any;
  // public showMenu: boolean;
  public legislatura;
  public legislaturas;
  public nombreLogo: any;
  public IMAGENESROUTE = environment.imagenes;
  private legislaturaChanges$: Subscription = null;
  constructor(private _api: ApiService) { }

  ngOnInit() {
    this.legislatura = this._api.getLegislatura();
    if (this.legislatura) {
      this.obtenerLogotipo(this.legislatura.idlegislatura);
    } else {
      this._api.get('actualLegislatura').subscribe(actualLegislatura => {
        let l = this._api.reader.read(actualLegislatura, [{}])[0];
        this._api.setLegislatura(l);
        this.obtenerLogotipo(l.idlegislatura);
      })
    }
    this._api.get('legislaturas').subscribe(response => {
      this.legislaturas = this._api.reader.read(response, []);
      this.iniciarMenu();
    })

    this.mainNavbar = $('.onepage .header_area.navbar');
    this.windowHeight = $(window).height()
    // this.showMenu = true;

    this.iniciarMenu();
    // this.iniciarBotonMenu();
    this.MenuLineHeight();
    // this.affixNavar();

    // $(window).scroll(() => {
    //   if ($(window).scrollTop() >= this.windowHeight - 600) {
    //     this.mainNavbar.addClass('sticky');
    //   } else {
    //     this.mainNavbar.removeClass('sticky');
    //   }
    // });

    $(window).resize(() => {
      this.MenuLineHeight();
      this.revisarMobile();
    });


    // Por ahora ya no habrá cambio de legislatura en la página, se comenta este observable
    // this.legislaturaChanges$ = this._api.cambioLegislatura$.subscribe((a) => {
    //   this.legislatura = this._api.getLegislatura();
    //   this.obtenerLogotipo(this.legislatura.idlegislatura);
    // })

  }

  ngOnDestroy() {
    // Eliminar suscripción del evento al cambiar legislatura
    this.legislaturaChanges$.unsubscribe();
  }

  // funcion para revisar si el mobille y poner el logo

  private revisarMobile() {
    let windowWidth = $(window).width();
    let windowHeight = $(window).height();
    let isMobile = windowWidth < 768;

    setTimeout(() => {
      isMobile ? $('.mean-bar').prepend(`<a href="/"><img id="imgLogoCongreso" alt="H. Congreso del Estado de Yucatán" src="${this.IMAGENESROUTE + this.nombreLogo.valor}"></a>`) : null;
    }, 500);
  }


  /**
   * LLama al API para obtener el nombre
   *  de la imagen que se va a mostrar
   * en el navbar
   */
  public obtenerLogotipo(idLegislatura) {
    this._api.get(`logo-legislatura/${idLegislatura}`).subscribe(response => {
      this.nombreLogo = this._api.reader.read(response, [{}])[0];
      setTimeout(() => {
        this.MenuLineHeight();
      }, 100);
    })
  }

  // public affixNavar() {
  //   //Affix
  //   this.mainNavbar.affix({
  //     offset: {
  //       top: 80
  //     }
  //   });
  // }

  //Menu Line Height
  public MenuLineHeight() {
    var windowWidth = $(window).width();
    var menuLineHeight = windowWidth * 0.05625;
    $('.navbar-nav > li > a, .logo_area > a').css('line-height', menuLineHeight + 'px');
  }

  // public iniciarBotonMenu() {
  // var menu_button = $('.menu-button');
  // var navItems = $('.navItems li.navItem');
  // menu_button.on('click', () => {
  //   this.showMenu = !this.showMenu;
  //   if (this.showMenu) {
  //     navItems.removeClass('hidden animated bounceOutUp').addClass('animated bounceInDown');
  //     setTimeout(() => {
  //       this.MenuLineHeight();
  //       this.affixNavar();
  //     }, 100);
  //   } else {
  //     navItems.removeClass('animated bounceInDown').addClass('animated bounceOutUp');
  //   }
  // })
  // }

  public iniciarMenu() {
    this.revisarMobile();
    // var navItems = $('.navItems li.navItem');
    // navItems.addClass('hidden');
    var navMenu: any = $('nav.mobile_menu');
    navMenu.meanmenu({
      meanScreenWidth: '767'
    });
    $('nav.mean-nav li > a:first-child').on('click', () => {
      $('a.meanmenu-reveal').click();
    });
  }

  public setLegislatura(l) {
    // Establece la legislatura en el servicio del API
    if (l) {
      this.legislatura = l;
      this._api.setLegislatura(l);
    }

  }
}
